import { activePage } from "../native/pages";
import type { NativeSession } from "../native/session";
import type { ImageStore } from "../render/image-store";
import { rasterizeMerge } from "../render/native-merge-raster";
import { createNativeNode } from "../native/document";
import { originalCompact } from "./native-original-controls";
import { originalIcon } from "./native-original-icons";
import { prepareFonts } from "./native-files";
export class NativeMerge {
  busy = false;
  private button = document.createElement("button");
  private row: HTMLElement;
  constructor(
    private session: NativeSession,
    private images: ImageStore,
    private changed: () => void,
    private prepare: () => boolean,
    private message: (text: string, error?: boolean) => void,
  ) {
    this.button.id = "merge-selected-layers";
    this.button.innerHTML = originalIcon("merge") + "Объединить слои";
    this.button.type = "button";
    this.button.onclick = () => void this.merge();
    document
      .querySelector("#native-right-panel .native-panel-scroll")!
      .append(this.button);
    this.row = originalCompact("native-merge-compact", [
      { id: this.button.id, icon: "merge", title: "Объединить слои" },
    ]);
  }
  private async merge() {
    if (this.busy || this.session.selectedNodes.length < 2 || !this.prepare())
      return;
    const snapshot = this.session.document,
      revision = this.session.revision,
      generation = this.session.generation,
      nodes = this.session.selectedNodes,
      ids = new Set(nodes.map((n) => n.id));
    this.busy = true;
    this.changed();
    try {
      await prepareFonts(snapshot);
      await this.images.prepare(snapshot.assets);
      const { source, x, y, width, height } = rasterizeMerge(
        snapshot,
        ids,
        this.images,
      );
      const asset = { id: crypto.randomUUID(), kind: "image" as const, source };
      await this.images.prepare([asset]);
      if (
        generation !== this.session.generation ||
        revision !== this.session.revision ||
        this.session.gesturing
      )
        throw new Error("Объединение отменено: документ изменился.");
      const node = createNativeNode(
        crypto.randomUUID(),
        "image",
        x + width / 2,
        y + height / 2,
        width,
        height,
      );
      node.media.image = asset.id;
      node.layer.name = "Объединённый слой";
      const page = activePage(snapshot),
        top = Math.max(...page.nodes.map((n, i) => (ids.has(n.id) ? i : -1))),
        result = page.nodes.flatMap((n, i) =>
          i === top ? [node] : ids.has(n.id) ? [] : [n],
        );
      this.session.document = {
        ...snapshot,
        assets: [...snapshot.assets, asset],
      };
      this.session.replaceNodes(result);
      this.session.select([node.id]);
      this.session.finish();
      this.message("Слои объединены. Отмена восстановит исходные объекты.");
    } catch (error) {
      this.message((error as Error).message, true);
    } finally {
      this.busy = false;
      this.changed();
    }
  }
  render() {
    this.button.hidden = this.session.selectedNodes.length < 2;
    this.button.disabled = this.busy;
    this.row.hidden = this.button.hidden;
    const parent = document.querySelector(
      "#native-compact-properties > .native-property-row",
    );
    if (parent && this.row.parentElement !== parent) parent.append(this.row);
    this.row.querySelector("button")!.disabled = this.busy;
  }
}
